
import React from 'react';
import Layout from '@/components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import MigrateSolutionData from '@/scripts/MigrateSolutionData';
import SuggestionsReview from '@/components/admin/SuggestionsReview';
import AdminProtectedRoute from '@/components/admin/AdminProtectedRoute';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import DynamicMetaTags from '@/components/DynamicMetaTags';

const AdminTools: React.FC = () => {
  const { logout } = useAdminAuth();

  return (
    <AdminProtectedRoute>
      <DynamicMetaTags
        title="Admin Tools - AIZen.tips"
        description="Admin tools for managing AIZen.tips platform"
        canonical="https://aizen.tips/admin/tools"
        isAdminPage={true}
      />
      
      <Layout className="pt-24">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-medium">Admin Tools</h1>
            <Button
              variant="outline"
              size="sm"
              onClick={logout}
              className="gap-2"
            >
              <LogOut className="h-4 w-4" />
              Logout
            </Button>
          </div>
          
          <Tabs defaultValue="suggestions" className="w-full">
            <TabsList className="mb-6">
              <TabsTrigger value="suggestions">Edit Suggestions</TabsTrigger>
              <TabsTrigger value="data-migration">Data Migration</TabsTrigger>
            </TabsList>
            
            <TabsContent value="suggestions" className="space-y-6">
              <p className="text-muted-foreground max-w-3xl">
                Review, approve or reject edit suggestions submitted by users.
              </p>
              <SuggestionsReview />
            </TabsContent>
            
            <TabsContent value="data-migration" className="space-y-6">
              <p className="text-muted-foreground max-w-3xl">
                These tools help migrate data to new structures or formats. Use with caution as they can modify large amounts of data at once.
              </p>
              <MigrateSolutionData />
            </TabsContent>
          </Tabs>
        </div>
      </Layout>
    </AdminProtectedRoute>
  );
};

export default AdminTools;
